import httpServiceShops from '../../services/httpServiceShops';
const endPoint = `retailers/sales_channels`;

export const getAllSalesChannels = () => {
  return (dispatch) => {
    httpServiceShops.get(`${endPoint}/all`, {}).then(data => {
      dispatch({ type: 'GET_SALES_CHANNELS', payload: data });
    }).catch((error) => {
      dispatch({ type: 'LOAD_DATA_FAILURE', error })
    });
  };
};

export const getSalesChannels = (params = {}) => {
  return (dispatch) => {
    httpServiceShops.get(endPoint, params).then(data => {
      dispatch({ type: 'GET_SALES_CHANNELS', payload: data });
    }).catch((error) => {
      dispatch({ type: 'LOAD_DATA_FAILURE', error })
    });
  };
};

export const createSalesChannel = (params = {}) => {
  return (dispatch) => {
    dispatch({ type: 'START_SAVING_SALES_CHANNEL_REQUEST'});
    httpServiceShops.post(endPoint, params).then(data => {
      showtoast(data.message);
      dispatch({ type: 'END_SAVING_SALES_CHANNEL_REQUEST'});
      dispatch({ type: 'CREATE_SALES_CHANNELS', payload: data });
    }).catch((error) => {
      showtoast(error.errors);
      dispatch({ type: 'END_SAVING_SALES_CHANNEL_REQUEST'});
    });
  };
};

export const updateSalesChannel = (web_id, params = {}) => {
  return (dispatch) => {
    dispatch({ type: 'START_SAVING_SALES_CHANNEL_REQUEST'});
    httpServiceShops.put(`${endPoint}/${web_id}`, params).then(data => {
      showtoast(data.message);
      dispatch({ type: 'END_SAVING_SALES_CHANNEL_REQUEST'});
      dispatch({ type: 'UPDATE_SALES_CHANNELS', payload: data });
    }).catch((error) => {
      showtoast(error.errors);
      dispatch({ type: 'LOAD_DATA_FAILURE', error });
      dispatch({ type: 'END_SAVING_SALES_CHANNEL_REQUEST'});
    });
  };
};

export const removeSalesChannel = (web_id) => {
  return (dispatch) => {
    httpServiceShops.remove(`${endPoint}/${web_id}`).then(data => {
      showtoast(data.message);
      dispatch({ type: 'REMOVE_SALES_CHANNELS', payload: data });
    }).catch((error) => {
      showtoast(error.errors);
      dispatch({ type: 'LOAD_DATA_FAILURE', error });
    });
  };
};